import { render, staticRenderFns } from "./HeaderLoginButtonRender.vue?vue&type=template&id=f99f711a"
import script from "./HeaderLoginButtonRender.vue?vue&type=script&lang=js"
export * from "./HeaderLoginButtonRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports